// const API url
export default {
  /**
   * Get user list
   * @method GET
   */
  getUserList: `https://jsonplaceholder.typicode.com/users`
};